import { Point } from '../../../common/maths/geometry/pointTypes';
import { Rect } from '../../../common/maths/geometry/rect/rectTypes';

export const TIPTAP_MOUNT_POINT_NAME = 'tiptap-popup-mount-point';

export const getTiptapPortalMountPoint = () => document.getElementById(TIPTAP_MOUNT_POINT_NAME);

export type PopupPosition = {
    anchor: 'top' | 'bottom';
    point: Point;
    anchorRect?: Rect;
};
